export const features = [
  {
    id: 1,
    title: "It maintains your health",
    description:
      "Our advanced form-tracking technology ensures proper exercise execution, maximizing your results while minimizing injury risk through real-time feedback.",
    icon: "star_rate_icon",
  },
  {
    id: 2,
    title: "Customized",
    description:
      "Experience personalized workout plans tailored to your goals, fitness level, and preferences using our sophisticated AI technology.",
    icon: "beenhere_icon",
  },
  {
    id: 3,
    title: "Easy to Use",
    description:
      "Intuitive interface and step-by-step guidance make fitness accessible to everyone, whether you're a beginner or advanced athlete.",
    icon: "auto_mode_icon",
  },
];

export const testimonial = [
  {
    id: 1,
    name: "Aditya Borkar",
    description:
      "As a fitness trainer, I'm impressed by the accuracy of form correction and rep counting. This app truly helps prevent injuries and ensures optimal results. A must-have for anyone serious about fitness.",
    role: "Fitness Trainer",
  },
  {
    id: 2,
    name: "Sahil Bhavsar",
    description:
      "This app transformed my fitness journey! The personalized guidance feels like having a personal trainer in my pocket. Perfect for both gym workouts and home training sessions.",
    role: "Gym Trainee",
  },
  {
    id: 3,
    name: "Omkar",
    description:
      "The precision in rep counting and form monitoring is remarkable. During intense sets, having this technology track my form has significantly improved my technique and results.",
    role: "Weight Lifter",
  },
];

export const homePageDiet = [
  {
    id: 1,
    title: "Diet Meal Plan to Lose Weight",
    route: "/weightloss",
    description:
      "Achieve sustainable weight loss with our balanced 1,500-calorie meal plan, designed to keep you satisfied and energized throughout your journey.",
    image:
      "https://images.pexels.com/photos/4929677/pexels-photo-4929677.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 2,
    title: "Diet Meal Plan to Gain Weight",
    route: "/weightgain",
    description:
      "Build lean muscle mass with our scientifically-backed meal plan featuring nutrient-dense foods and optimal macro distributions.",
    image:
      "https://images.pexels.com/photos/4929692/pexels-photo-4929692.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 3,
    title: "Healthy Eating Plate",
    route: "/healthy",
    description:
      "Master balanced nutrition with our comprehensive guide to portion control and food group distribution, perfect for maintaining long-term health.",
    image:
      "https://images.pexels.com/photos/793765/pexels-photo-793765.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
];

export const HomePageActivity = [
  {
    id: 1,
    title: "Yoga",
    route: "/yoga",
    description:
      "Discover inner peace and physical flexibility through our comprehensive collection of yoga practices, suitable for all experience levels.",
    image:
      "https://images.pexels.com/photos/9271215/pexels-photo-9271215.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 2,
    title: "Strength Training",
    route: "/workout",
    description:
      "Build muscle, boost metabolism, and enhance overall fitness with our progressive resistance training programs designed for all fitness levels.",
    image:
      "https://images.pexels.com/photos/10360933/pexels-photo-10360933.jpeg?auto=compress&cs=tinysrgb&w=500",
  },
];

export const YogaVariation = [
  {
    id: 1,
    title: "Virabhadrasana",
    route: "/virabhadrasana",
    description:
      "Master the Warrior Pose to build strength, stability, and confidence. This powerful stance improves focus while strengthening your entire body.",
    image:
      "https://images.squarespace-cdn.com/content/v1/5f35301faed3a85bf80f77ed/1600440219305-RZTH2MR2SAW2HWNGMUNG/img_news1.jpg",
  },
  {
    id: 2,
    title: "Trikonasana",
    route: "/trikonasana",
    description:
      "Perfect your Triangle Pose to enhance flexibility, strengthen your core, and improve spinal alignment while promoting full-body awareness.",
    image:
      "https://images.pexels.com/photos/5384538/pexels-photo-5384538.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 3,
    title: "AdhoMukhaSvanasana",
    route: "/adhomukhasvanasana",
    description:
      "Experience the benefits of Downward-Facing Dog, a rejuvenating pose that stretches and strengthens your entire body while calming the mind.",
    image: "https://www.yogateket.com/image/original/downwardfacingdog.jpg",
  },
];

export const WorkoutVariation = [
  {
    id: 1,
    title: "Push Up",
    route: "/pushups",
    description:
      "Master the fundamental upper body exercise that builds chest, shoulder, and core strength while improving overall stability and endurance.",
    image:
      "https://images.pexels.com/photos/2780762/pexels-photo-2780762.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 2,
    title: "Squat",
    route: "/squats",
    description:
      "Perfect your squat technique to build powerful legs, strengthen your core, and boost overall functional fitness and athletic performance.",
    image:
      "https://images.pexels.com/photos/6998874/pexels-photo-6998874.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 3,
    title: "Crunches",
    route: "/crunches",
    description:
      "Develop a strong core and defined abs with proper crunch technique, targeting multiple abdominal muscles for comprehensive midsection development.",
    image:
      "https://images.pexels.com/photos/5262853/pexels-photo-5262853.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 4,
    title: "Bicep Curls",
    route: "/bicepcurls",
    description:
      "Build impressive arm strength and definition with proper bicep curl technique, focusing on controlled movement and maximum muscle engagement.",
    image:
      "https://images.pexels.com/photos/7188078/pexels-photo-7188078.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
];

export default features;